import React from 'react'
import PropTypes from 'prop-types'

import ContentHolder from '../../ui/ContentHolder'

import Agent from './Agent'
import styles from './styles.scss'

const renderAgents = (agents, campaign) => {
  if (campaign.agents){
    return campaign.agents.map((agentId) => {
      const agent = agents[agentId] || {}
      return (
        <Agent key={agent.id} agent={agent} />
      )
    })
  }

  return null
}

const Agents = (props) => {
  const { agents, campaign } = props

  return (
    <div className={styles.root}>
      <ContentHolder>
        <h4>Your sales agents</h4>

        {renderAgents(agents, campaign)}
      </ContentHolder>
    </div>
  )
}

Agents.propTypes = {
  agents: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default Agents
